export default __webpack_public_path__ + "static/itreview-banner-471372c8b16e76ecc992e578ffbe8629.png";